module.exports = __webpack_public_path__ + "img/92f868c.png";